import { Component } from '@theme/component';

class SodPurchaseOptions extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#sync);
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#sync);
  }

  #sync = () => {
    const checked = this.querySelector('input[name="selling_plan"]:checked');
    const form = document.getElementById(this.dataset.formId ?? '');
    const button = form?.querySelector('[ref="addToCartButton"]');
    if (!checked || !button) return;

    const label = checked.dataset.label;
    if (!label) return;

    const textNode = [...button.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
    if (textNode) textNode.textContent = ` ${label} `;
    else button.prepend(document.createTextNode(` ${label} `));
  };
}

if (!customElements.get('sod-purchase-options')) customElements.define('sod-purchase-options', SodPurchaseOptions);
